import React from "react";
import type Stripe from "stripe";

import { FlexBox } from "js/react/components/LayoutGrid";
import { CreditCardIcon } from "js/react/views/UserOptions/panes/BillingPane/Components/CreditCardIcon";
import { LinkByStripeIcon } from "js/react/views/UserOptions/panes/BillingPane/Components/LinkByStripeIcon";
import { Button } from "js/Components/Button";
import { themeColors } from "js/react/sharedStyles";
import { ShowDialogAsync, ShowErrorDialog } from "js/react/components/Dialogs/BaseDialog";
import ChangePaymentMethodDialog from "js/react/views/Billing/dialogs/ChangePaymentMethodDialog";

export const PaymentMethodSection = ({ paymentMethod, setPaymentMethod }: {
    paymentMethod: Stripe.PaymentMethod | null;
    setPaymentMethod: (any) => void;
}

) => {
    const handleAddPaymentMethod = async () => {
        const result = await ShowDialogAsync(ChangePaymentMethodDialog);
        if (result && result?.type) {
            setPaymentMethod(result);
        } else if (result && result.canceled) {
            return;
        } else {
            ShowErrorDialog({
                title: "Error adding payment method"
            });
        }
    };

    return (
        <FlexBox left between fillWidth>
            {paymentMethod?.card
                ? <FlexBox left>
                    <CreditCardIcon small card={paymentMethod.card as Stripe.PaymentMethod.Card} />
                    <div data-test-id="payment-method-card-info">****{paymentMethod.card.last4}</div>
                </FlexBox>
                : paymentMethod?.type === "link"
                    ? <div data-test-id="payment-method-card-info">
                        <LinkByStripeIcon /></div>
                    : <div data-test-id="payment-method-card-info">Payment information missing</div>
            }
            <Button
                unframed
                large
                color={themeColors.ui_blue}
                onClick={handleAddPaymentMethod}
                data-test-id="payment-method-section-edit-button">
                {paymentMethod?.type ? "edit" : "add"}
            </Button>
        </FlexBox>

    );
};
